import { memo, useMemo } from "react";
import QueryNode from "../../components/QueryTableNode";
import { useQueryGeneratorContext } from "../../context/QueryBuilder/QueryGeneratorContext";

const SemanticTableNode = (props: any) => {
  const {
    data: {
      content: columns,
      header: tableName,
      tableItem,
    },
  } = props;

  const { handleOnTableChange, handleOnBodyCheckChange, selectedTableNames } = useQueryGeneratorContext();
  const isTableSelected = useMemo(() => selectedTableNames.includes(tableName), [selectedTableNames, tableName])

  const config = useMemo(() => {
    return {
      columnCheck: isTableSelected ? '': 'invisible'
    }
  }, [isTableSelected])

  return (
    <QueryNode
      tableName={tableName}
      columns={columns}
      isTableChecked={isTableSelected}
      checkedColumns={tableItem.columns}
      onTitleCheckChange={handleOnTableChange}
      onBodyCheckChange={handleOnBodyCheckChange}
      classes={config}
    />
  );
};

export default memo(SemanticTableNode);